"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _constants = require("../constants");
var _shadows = require("../shadows");
const styleOverrides = {
  root: ({
    ownerState,
    theme
  }) => ({
    lineHeight: 1.5,
    borderRadius: 25,
    ...(ownerState.variant === 'contained' && ownerState.color === 'primary' && {
      color: _constants.colors.defaultColors.contrastText,
      background: _constants.colors.defaultColors.dark,
      '&:hover': {
        background: _constants.colors.oriGrey.A700,
        color: _constants.colors.defaultColors.contrastText
      },
      [`&.${_material.buttonClasses.disabled}`]: {
        color: _constants.colors.defaultColors.light,
        background: _constants.colors.oriGrey[200]
      }
    }),
    // same as previous ... obsolete
    ...(ownerState.color === 'bannerButton' && {
      color: _constants.colors.defaultColors.contrastText,
      background: _constants.colors.defaultColors.dark,
      borderColor: 'transparent',
      '&:hover': {
        background: _constants.colors.oriGrey.A700,
        borderColor: 'transparent',
        color: _constants.colors.defaultColors.contrastText
      },
      [`&.${_material.buttonClasses.disabled}`]: {
        color: _constants.colors.defaultColors.light,
        background: _constants.colors.oriGrey[200],
        borderColor: 'transparent'
      }
    }),
    ...(ownerState.variant === 'outlined' && (ownerState.color === 'default' || ownerState.color === 'primary') && {
      color: _constants.colors.defaultColors.dark,
      border: `1px solid ${_constants.colors.defaultColors.dark}`,
      '&:hover': {
        color: _constants.colors.defaultColors.dark,
        border: `1px solid ${_constants.colors.defaultColors.dark}`,
        background: _constants.colors.oriGrey[200]
      },
      [`&.${_material.buttonClasses.disabled}`]: {
        color: _constants.colors.defaultColors.light,
        background: _constants.colors.oriGrey[200],
        borderColor: 'transparent'
      }
    }),
    // same as previous ... obsolete
    ...(ownerState.variant === 'contained' && ownerState.color === 'secondary' && {
      color: _constants.colors.defaultColors.dark,
      background: _constants.colors.commonColors.white,
      border: `1px solid ${_constants.colors.defaultColors.dark}`,
      '&:hover': {
        color: _constants.colors.defaultColors.dark,
        border: `1px solid ${_constants.colors.defaultColors.dark}`,
        background: _constants.colors.oriGrey[200]
      },
      [`&.${_material.buttonClasses.disabled}`]: {
        color: _constants.colors.defaultColors.light,
        background: _constants.colors.oriGrey[200],
        borderColor: 'transparent'
      }
    }),
    ...(ownerState.variant === 'contained' && ownerState.color === 'superApp' && {
      background: `linear-gradient(90deg, ${_constants.colors.superApp.light} 0%, ${_constants.colors.superApp.main} 100%)`,
      '&:hover': {
        boxShadow: _shadows.SHADOW_LEVEL2
      },
      [`&.${_material.buttonClasses.disabled}`]: {
        background: _constants.colors.action.disabledBackground
      }
    }),
    ...(ownerState.variant === 'outlined' && ownerState.color === 'superApp' && {
      borderWidth: '3px',
      borderColor: _constants.colors.superApp.main,
      '&:hover': {
        borderWidth: '3px',
        boxShadow: _shadows.SHADOW_LEVEL2
      },
      [`&.${_material.buttonClasses.disabled}`]: {
        borderWidth: '3px'
      }
    }),
    ...(ownerState.variant === 'contained' && ownerState.color === 'default' && {
      color: theme.palette[ownerState.color].main,
      backgroundColor: theme.palette[ownerState.color].contrastText,
      boxShadow: theme.shadows[2],
      '&:hover': {
        color: theme.palette[ownerState.color].main,
        backgroundColor: theme.palette[ownerState.color].contrastText,
        boxShadow: theme.shadows[3],
        '@media (hover: none)': {
          boxShadow: theme.shadows[2],
          backgroundColor: theme.palette[ownerState.color].contrastText
        }
      },
      '&:active': {
        boxShadow: theme.shadows[8]
      },
      [`&.${_material.buttonClasses.focusVisible}`]: {
        boxShadow: theme.shadows[6]
      },
      [`&.${_material.buttonClasses.disabled}`]: {
        color: theme.palette.grey[400],
        backgroundColor: theme.palette[ownerState.color].contrastText,
        boxShadow: theme.shadows[2]
      }
    })
  }),
  sizeSmall: ({
    ownerState
  }) => ({
    padding: '9px 20px',
    lineHeight: 1.4,
    ...(ownerState.variant === 'outlined' && ownerState.color === 'superApp' && {
      padding: '7px 20px'
    })
  }),
  iconSizeSmall: {
    fontSize: '2.4rem',
    marginTop: '-0.4rem',
    marginBottom: '-0.4rem'
  },
  sizeMedium: ({
    ownerState
  }) => ({
    padding: '12px 23px',
    ...(ownerState.variant === 'outlined' && ownerState.color === 'superApp' && {
      padding: '10px 20px',
      lineHeight: 1.443
    })
  }),
  iconSizeMedium: {
    fontSize: '2.6rem',
    marginTop: '-0.4rem',
    marginBottom: '-0.4rem'
  },
  sizeLarge: ({
    ownerState
  }) => ({
    padding: '14px 23px',
    lineHeight: 1.25,
    ...(ownerState.variant === 'outlined' && ownerState.color === 'superApp' && {
      padding: '11px 20px'
    })
  }),
  iconSizeLarge: {
    fontSize: '2.8rem',
    marginTop: '-0.5rem',
    marginBottom: '-0.5rem'
  },
  startIcon: {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- css selector
    '>*:nth-of-type(1)': {
      fontSize: 'inherit'
    }
  },
  endIcon: {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- css selector
    '>*:nth-of-type(1)': {
      fontSize: 'inherit'
    }
  },
  text: {
    padding: '10px 23px'
  },
  textPrimary: {
    color: _constants.colors.defaultColors.dark,
    '&:hover': {
      color: _constants.colors.defaultColors.dark
    }
  },
  contained: {
    borderRadius: 25
  },
  outlined: {
    borderRadius: 25,
    lineHeight: 1.386
  },
  outlinedSizeSmall: {
    lineHeight: 1.277
  }
};
const defaultProps = {
  disableElevation: true,
  color: 'default'
};
var _default = exports.default = {
  defaultProps,
  styleOverrides
};
